import { Injectable } from '@angular/core';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
import { AppointmentParking } from '../business-entities/dealer-parking-model';
import { Comments, DemandComments } from '../business-entities/dwo-comments.model';
import { FilesByAppointmentIdResponseModel } from '../business-entities/dwo-documents.model';
import { GenericResponse } from '../business-entities/generic-response';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';

@Injectable({
  providedIn: 'root'
})
export class DwoDocumentsDataService {

  constructor(private dataService: DataService) { }
  getDwoDocumentList(appointmentGUID: string, langCode: string): Promise<GenericResponse<FilesByAppointmentIdResponseModel>>{
    return this.dataService.Get<GenericResponse<FilesByAppointmentIdResponseModel>>(Urls.GetAppointmentFiles, appointmentGUID, langCode).toPromise();
  }

  getDwoDemandComments(appointmentId: number): Promise<GenericResponse<Array<DemandComments>>> {
    return this.dataService.Get<GenericResponse<Array<DemandComments>>>(Urls.GetAppointmentDemandComments, appointmentId).toPromise();
  }

  getDwoComments(appointmentId: number): Promise<GenericResponse<Array<Comments>>>{
    return this.dataService.Get<GenericResponse<Array<Comments>>>(Urls.GetAppointmentComments, appointmentId).toPromise();
  } 
  getAppointmentParkingImage(appointmentId: string): Promise<GenericResponse<AppointmentParking>>{
    return this.dataService.Get<GenericResponse<AppointmentParking>>(Urls.GetAppointmentParkingImage,appointmentId).toPromise();
  }
  addInternalComment(model:any):Promise<any>{
    return this.dataService.Post<any>(Urls.AddInternalComments,model).toPromise();
  }
  DeleteInternalComment(model:any):Promise<any>{
    return this.dataService.Post<any>(Urls.DeleteInternalComments,model).toPromise();
  }
  EditInternalComment(model:any):Promise<any>{
    return this.dataService.Post<any>(Urls.EditInternalComments,model).toPromise();
  }
  EditMediaVisibility(model:any):Promise<any>{
    return this.dataService.Post<any>(Urls.EditMediaVisibility,model).toPromise();
  }
  DownloadFile(fileName: string): Promise<any> {
    return this.dataService.Get<any>(Urls.DownloadFile, fileName).toPromise();
  }
  deleteDocument(model:any): Promise<any>{
    return this.dataService.Post<any>(Urls.DeleteDocument, model).toPromise();
  }
}
